export default {"src":"/_next/static/media/sketch.f176352b.svg","height":232,"width":256,"blurWidth":0,"blurHeight":0};